export const containerStyles = `
    flex flex-col items-center justify-center gap-[16px] flex-1
    w-full h-full p-[16px]
    bg-base-white
`

export const headerWithDescriptionContainerStyles = `
    flex flex-col items-center gap-[8px]
    w-full max-w-[45%]
    text-center
`

export const errorHeaderTextStyles = `
    text-[24px] font-bold
    text-gray-800
`

export const errorDescriptionTextStyles = `
    text-md-medium
    text-gray-600
`

export const errorImageStyles = `
    w-full max-w-[200px] h-full max-h-[200px]
`
